module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("The author grew up in South Dublin. He subsequently obtained three university degrees; at University College Dublin (BA Social Science), University of Surrey (MSC Applied Social Studies), University of London (BA Philosophy). After working in banking, on building sites and with alcoholics, he spent the majority of his career in the Probation Service in London, including two spells working in London prisons. Since retiring he has been writing poetry and short stories. This is his first novel. He enjoys running and is still competing in half marathons. He lives in Buckinghamshire with his wife and has two adult children.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0